<section class="content-header" style="padding: 0.5% !important;">
    <div class="container-fluid">
        <div class="row mb-2">
            <div class="col-md-6">
                <ol class="breadcrumb float-sm-left">
                    <li class="breadcrumb-item">
                        <a [routerLink]="['/']"><i class="fas fa-home"></i> &nbsp;Trang chủ</a>
                    </li>
                    <li class="breadcrumb-item active">Tổng hợp nợ học phí kinh phí</li>
                </ol>
            </div>
            <div class="col-md-6">
                <button class="btn btn-info btn-sm" (click)="submit()" style="float: right; margin-right: 5px;">
                    <i class="fas fa-search"></i> Thống kê dữ liệu
                </button>
                <button class="btn btn-success btn-sm" (click)="Excel()" style="float: right; margin-right: 5px;">
                    <i class="fas fa-file-excel"></i> Xuất excel 
                </button>
                <button class="btn btn-warning btn-sm" type="submit" style="float: right;margin-right: 5px; ">
                    <i class="fas fa-info-circle"></i>
                    Hướng dẫn
                </button>
            </div>
        </div>
    </div>
</section>
<section class="content cus-body">
    <div class="card">
        <div class="card-body">
            <form class="form-horizontal" [formGroup]="filter">
                <div class="row">
                    <div class="col-md-2 ">
                        <label>Hệ</label>
                        <select class="form-control" (change)="changeHe()" formControlName="ID_he">
                            <option *ngFor="let i of dataHe" value="{{i.ID_he}}">{{i.Ten_he}}</option>
                        </select>
                    </div>
                    <div class="col-md-2">
                        <label>Khoa</label>
                        <select class="form-control" formControlName="ID_khoa" (change)="changeKhoa()">
                            <option value="">Tất cả</option>
                            <option *ngFor="let i of dataKhoa" value="{{i.ID_khoa}}">{{i.Ten_khoa}}</option>
                        </select>
                    </div>
                    <div class="col-md-2">
                        <label>Khóa</label>
                        <select class="form-control" formControlName="Khoa_hoc" (change)="changeKhoaHoc()">
                            <option value="">Tất cả</option>
                            <option *ngFor="let i of dataKhoaHoc2" value="{{i.Khoa_hoc}}">{{i.Khoa_hoc}}</option>
                        </select>
                    </div>
                    <div class="col-md-2">
                        <label>Chuyên ngành</label>
                        <select class="form-control" formControlName="ID_chuyen_nganh" (change)="changeChuyenNganh()">
                            <option value="">Tất cả</option>
                            <option *ngFor="let i of dataChuyenNganh2" value="{{i.ID_chuyen_nganh}}">{{i.Chuyen_nganh}}
                            </option>
                        </select>
                    </div>
                    <div class="col-md-2">
                        <label>Lớp</label>
                        <select class="form-control" formControlName="ID_lop">
                            <option value="">Tất cả</option>
                            <option *ngFor="let i of dataLop2" value="{{i.ID_lop}}">{{i.Ten_lop}}</option>
                        </select>
                    </div>
                    <div class="col-md-2">
                        <label>Khoản nộp</label>
                        <select class="form-control" formControlName="cmbTongHop">
                            <option value="0">Học phí</option>
                            <option value="1">Kinh phí đào tạo</option>
                            <option value="2">Học phí và Kinh phí đào tạo</option>
                        </select>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-2">
                        <label>Học kỳ</label>
                        <select class="form-control" formControlName="Hoc_ky">
                            <option value="1">Học kỳ I</option>
                            <option value="2">Học kỳ II</option>
                        </select>
                    </div>
                    <div class="col-md-2">
                        <label>Năm học</label>
                        <select class="form-control" formControlName="Nam_hoc">
                            <option *ngFor="let i of Nam_hoc_arr" value="{{i.value}}">{{i.name}}</option>
                        </select>
                    </div>
                    <div class="col-md-2">
                        <label>Đợt</label>
                        <select class="form-control" formControlName="Dot">
                            <option value="0">0</option>
                            <option value="1">1</option>
                            <option value="2">2</option>
                            <option value="3">3</option>
                            <option value="4">4</option>
                            <option value="5">5</option>
                            <option value="6">6</option>
                            <option value="7">7</option>
                            <option value="8">8</option>
                            <option value="9">9</option>
                            <option value="10">10</option>
                            <option value="11">11</option>
                            <option value="12">12</option>
                            <option value="13">13</option>
                            <option value="14">14</option>
                            <option value="15">15</option>
                        </select>
                    </div>
                    <div class="col-md-2">
                        <input type="checkbox" formControlName="dtpTu_ngay">&nbsp;<label>Từ ngày</label>
                        <input type="date" class="form-control" formControlName="Tu_ngay">
                    </div>
                    <div class="col-md-2">
                        <input type="checkbox" formControlName="dtpDen_ngay">&nbsp;<label>Đến ngày</label>
                        <input type="date" class="form-control" formControlName="Den_ngay">
                    </div>
                    <div class="col-md-2">
                        <div class="mt-4">
                            <input type="radio" name="radTheo_ky" value="true" formControlName="radTheo_ky"> Học kỳ
                            <input type="radio" name="radTheo_ky" value="false" formControlName="radTheo_khoa"> Toàn khoá
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</section>
<section class="content cus-body">
    <div class="card">
        <div class="card-body">
            <div class="table-responsive" style="width: 100%;height: auto; max-height: 50vh;">
                <table class="table table-bordered table-fixed" style="width: 100%;">
                    <thead>
                        <tr>
                            <th>Mã sv</th>
                            <th>Họ và tên</th>
                            <th>Tên lớp</th>
                            <th>Dư đầu kỳ</th>
                            <th>Phải nộp kỳ</th>
                            <th>Miễn giảm kỳ</th>
                            <th>Còn nộp kỳ</th>
                            <th>Đã nộp kỳ</th>
                            <th>Hoàn trả kỳ</th>
                            <th>Dư trong kỳ</th>
                            <th>Dư cuối kỳ</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let i of dataTable">
                            <td>{{i.Ma_sv}}</td>
                            <td>{{i.Ho_ten}}</td>
                            <td>{{i.Ten_lop}}</td>
                            <td>{{i.Thieu_thua_ky_truoc|number}}</td>
                            <td>{{i.So_tien_phai_nop|number}}</td>
                            <td>{{i.So_tien_mien_giam|number}}</td>
                            <td>{{i.So_tien_nop|number}}</td>
                            <td>{{i.So_tien_da_nop|number}}</td>
                            <td>{{i.So_tien_tra_lai|number}}</td>
                            <td>{{i.Thieu_thua|number}}</td>
                            <td>{{i.Thieu_thua_cuoi_cung|number}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <span style="float:right"><b>Tổng số bản ghi</b>: {{recordTotal|number}}</span>

        </div>
    </div>
</section>